enum PolicyEvalDisposition {
  NO_MATCH = 'NO_MATCH',
  MATCH = 'MATCH',
  EXCEPTION = 'EXCEPTION',
  DISABLED = 'DISABLED',
  EVALEXCEPTION = 'EVALEXCEPTION',
  INVALID = 'INVALID',
}

// enum PolicyExecutionStatus {
//   DISABLED= 'DISABLED',
//   CONDITIONFAILED = 'CONDITIONFAILED',
//   NOENABLEDPOLICY = 'NOENABLEDPOLICY',
//   NOPOLICYDEFINED = 'NOPOLICYDEFINED',
//   EVALEXCEPTION = 'EVALEXCEPTION',
//   UNKNOWNACTION = 'UNKNOWNACTION',
//   INVALIDACTIONREFERENCE = 'INVALIDACTIONREFERENCE'
// }

export default PolicyEvalDisposition;
